module.exports = __webpack_public_path__ + "img/icon-two.0159542e.svg";